import Login from "./pages/login/index.jsx";
import './style/global.css';
import { Routes, Route } from 'react-router-dom';
import Principal from './pages/principal/index.jsx';
import Saldo from './pages/saldo/index.jsx';
import Categoria from './pages/categoria/index.jsx';
import Pessoa from './pages/pessoa/index.jsx';
import Meta from './pages/meta/index.jsx';
import Lancamento from './pages/lancamento/index.jsx';
import Assinatura from "./pages/assinatura/index.jsx";
import { Toaster } from 'react-hot-toast';
import PrivateRoute from "./componente/PrivateRoute.jsx";

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/assinatura" element={<Assinatura />} />

        <Route path="/principal" element={<PrivateRoute><Principal /></PrivateRoute>} />            
        <Route path="/saldo" element={<PrivateRoute><Saldo /></PrivateRoute>} /> 
        <Route path="/categoria" element={<PrivateRoute><Categoria /></PrivateRoute>} /> 
        <Route path="/pessoa" element={<PrivateRoute><Pessoa /></PrivateRoute>} /> 
        <Route path="/meta" element={<PrivateRoute><Meta /></PrivateRoute>} /> 
        <Route path="/lancamento" element={<PrivateRoute><Lancamento /></PrivateRoute>} /> 
      </Routes>
    </>
  );
}

export default App;